import { createFileRoute, redirect } from '@tanstack/react-router';
import { getCurrentUser } from 'aws-amplify/auth';
import { AppShellLayout } from '../app/layout/app-shell.layout';

export const Route = createFileRoute('/_app')({
  component: RouteComponent,
  errorComponent: () => {
    return <div>Error</div>;
  },
  loader: async () => {
    try {
      const user = await getCurrentUser();
      if (!user) {
        return redirect({ to: '/login' });
      }
    } catch {
      return redirect({ to: '/login' });
    }
  },
});

function RouteComponent() {
  return <AppShellLayout />;
}
